import { ResponsiveLine } from '@nivo/line';

const usersData = [
  {
    id: 'new_users',
    data: [
      { x: 'Jan', y: 120 },
      { x: 'Feb', y: 150 },
      { x: 'Mar', y: 210 },
      { x: 'Apr', y: 180 },
      { x: 'May', y: 250 },
      { x: 'Jun', y: 310 },
      { x: 'Jul', y: 290 },
      { x: 'Aug', y: 350 },
      { x: 'Sep', y: 420 },
      { x: 'Oct', y: 380 },
      { x: 'Nov', y: 450 },
      { x: 'Dec', y: 550 }
    ]
  }
];

export const UsersGrowthChart = () => (
  <div style={{ height: '300px' }}>
    <ResponsiveLine
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'Month',
        legendOffset: 36,
        legendPosition: 'middle'
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'User Count',
        legendOffset: -40,
        legendPosition: 'middle'
      }}
      axisRight={null}
      axisTop={null}
      data={usersData}
      legends={[
        {
          anchor: 'bottom-right',
          direction: 'column',
          justify: false,
          translateX: 100,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: 'left-to-right',
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: 'circle'
        }
      ]}
      margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
      pointBorderColor={{ from: 'serieColor' }}
      pointBorderWidth={2}
      pointColor={{ theme: 'background' }}
      pointSize={10}
      useMesh={true}
      xScale={{ type: 'point' }}
      yFormat=" >-.2f"
      yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
    />
  </div>
);
